import { useEffect, useState } from "react";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { BasicTable, MASK_NUMBER, MASK_TEXT_NOWRAP } from "../../../theme/Component/BasicTable";
import { ModalConfirm } from "../../../theme/Component/ModalConfirm";
import { Modal } from "../../../theme/Component/Modal";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { _Product } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { TaxSchemaValuesForAddedValue } from "./TaxSchemeValuesForAdded/TaxSchemaValuesForAddedValue";
import { toast } from "react-toastify";

interface Props {
    _idProduct: number;
}

export const ProductTaxsCatalogForAddedValue = ({ _idProduct }: Props) => {

    const { lista, setLista, bean, setBean, instance } = useDataBean(_Product);

    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    const [taxScheme, setTaxScheme] = useState<any>({});


    useEffect(() => {
        if (_idProduct) {
            getLista()
        }
    }, [_idProduct])

    const getLista = () => {
        instance.getProductTaxsCatalogForAddedValue(_idProduct).then(
            (rta: any) => {
                setLista(rta)
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const addItem = () => {
        instance.addProductTax(_idProduct, taxScheme.IDTaxSchemeValue).then(
            (resp) => {
                setModal({ ...modal, "view": false })
                getLista()
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const deleteObjec = () => {
        instance.removeProductTax(_idProduct, bean.IDTaxSchemeValue).then(
            (resp) => {
                setModalC({ ...modalC, "view": false })
                getLista()
            }
        ).catch(
            err => { console.log(err) }
        )
    }

    const head = [
        { title: 'ID', property: 'IDProductTax', visible: true, mask: MASK_NUMBER },
        { title: 'Tipo de Impuesto', property: 'TaxSchemeName', visible: true, },
        { title: 'Tipo de Tarifa', property: 'TaxValueName', visible: true, mask: MASK_TEXT_NOWRAP },
        { title: 'Tarifa', property: 'ValueTypeName', visible: true },
        { title: 'Valor', property: 'TaxValue', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { setModal({ ...modal, "view": true, "name": "Agregar Impuestos de Valor Agregado" }) } }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true, "name": `Eliminar Impuestos de Valor Agregado` }) } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    useEffect(() => {
        setTaxScheme({})
    }, [modal.view])

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable iconButtons={iconButtonsItem} listButtons={listaBotones()} head={head} body={lista} rowSet={setBean} />
            </div>

            <div className="col-md-12">
                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={() => { deleteObjec() }}>
                    <strong>Eliminar {bean.IDProductTax} - {bean.TaxSchemeName}</strong>
                </ModalConfirm>
            </div>

            <div className="col-md-12">
                <Modal modal={modal} updateModal={setModal} onSubmitLabel="Agregar Impuesto" eventModal={() => {
                    if (taxScheme.IDTaxSchemeValue) {
                        addItem()
                    } else {
                        toast.error("Impuesto no Valido")
                    }
                }}>
                    <TaxSchemaValuesForAddedValue onChange={(e) => { setTaxScheme(e) }} idProduct={_idProduct} />
                </Modal>
            </div>
        </div >
    )
}



